const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

(() => {
  const unavailableColours = new Set(['Pink', 'Black']);

  const italian = () =>
    document.documentElement.lang.toLowerCase().startsWith('it');

  const unavailableText = () =>
    italian() ? 'Non disponibile' : 'Unavailable';

  const colourText = (value) => {
    if (!italian()) return value;
    if (value === 'Pink') return 'Rosa';
    if (value === 'Black') return 'Nero';
    return value;
  };

  function sectionFrom(root = document) {
    if (root?.matches?.('[data-ngfb]')) return root;
    return root?.querySelector?.('[data-ngfb]') || null;
  }

  function patchUnavailableProductColours(section) {
    section
      .querySelectorAll('select[data-master-colour], select[data-item-colour]')
      .forEach((select) => {
        Array.from(select.options).forEach((option) => {
          if (!unavailableColours.has(option.value)) return;
          option.disabled = true;
          const expected = `${colourText(option.value)} — ${unavailableText()}`;
          if (option.textContent !== expected) option.textContent = expected;
        });

        if (select.selectedOptions[0]?.disabled) {
          const firstEnabled = Array.from(select.options).find(
            (option) => !option.disabled
          );
          if (firstEnabled) {
            select.value = firstEnabled.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      });

    const sticky = section.querySelector('[data-sticky-variant]');
    if (sticky) {
      Array.from(sticky.options).forEach((option) => {
        if (!option.disabled) return;
        const match = option.textContent.trim().match(
          /^(.+?)\s*\/\s*(Pink|Black)$/i
        );
        if (!match) return;
        const rawColour =
          match[2].toLowerCase() === 'pink' ? 'Pink' : 'Black';
        const expected =
          `${match[1]} / ${colourText(rawColour)} — ${unavailableText()}`;
        if (option.textContent !== expected) option.textContent = expected;
      });
    }
  }

  function patchBundlePrices(section) {
    const replacements = new Map([
      ['€28.99', '€29.99'],
      ['€74.99', '€75.99'],
    ]);

    section.querySelectorAll('.offer-price').forEach((price) => {
      const textNode = Array.from(price.childNodes).find(
        (node) => node.nodeType === Node.TEXT_NODE
      );
      if (!textNode) return;

      const current = textNode.nodeValue.trim();
      const replacement = replacements.get(current);
      if (!replacement) return;

      textNode.nodeValue = textNode.nodeValue.replace(current, replacement);
    });
  }

  function applyFirstBraPatch(root = document) {
    const section = sectionFrom(root);
    if (!section) return;
    patchUnavailableProductColours(section);
    patchBundlePrices(section);
  }

  document.addEventListener('DOMContentLoaded', () => {
    applyFirstBraPatch(document);
  });

  document.addEventListener('shopify:section:load', (event) => {
    applyFirstBraPatch(event.target);
  });
})();
